import { render, staticRenderFns } from "./indexRenovation.vue?vue&type=template&id=43556448&scoped=true"
import script from "./indexRenovation.vue?vue&type=script&lang=js"
export * from "./indexRenovation.vue?vue&type=script&lang=js"
import style0 from "./indexRenovation.vue?vue&type=style&index=0&id=43556448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43556448",
  null
  
)

export default component.exports